import React, { useState } from 'react';
import {
  TextField,
  Switch,
  FormControlLabel,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  Container,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { SetGrupCreate } from '../../Conections/AcademicConection';

const GroupCreate = () => {

  const goTo = useNavigate();
  const { getToken, getCompany } = useAuth();

  const [grupo, setGrupo] = useState({
    nombre: '',
    descripcion: '',
    show: false,
  });

  const [errors, setErrors] = useState({});

  React.useEffect(() => {
    reloaduser();
  }, []);

  async function reloaduser() {
    if (getToken()) {
      const permisionCan = await can(getToken(), getCompany(), "/academic/creategroup");
      if (permisionCan === 0) {
        goTo("/dashboard");
      }
    }
    else {
      goTo(`/login`);
    }
  }

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    setGrupo(prevGrupo => ({
      ...prevGrupo,
      [name]: name === 'show' ? checked : value
    }));
    // Limpiar el error cuando el usuario comienza a escribir
    if (errors[name]) {
      setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!grupo.nombre.trim()) {
      newErrors.nombre = 'El nombre es requerido';
    }
    if (!grupo.descripcion.trim()) {
      newErrors.descripcion = 'La descripción es requerida';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {

      const datos = await SetGrupCreate(
        getToken(),
        getCompany(),
        grupo.nombre,
        grupo.descripcion,
        1,
        grupo.show?1:0
      );
      goTo(`/academic/showgroup/${datos}`);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          Crear Nuevo Grupo
        </Typography>
        <Card>
          <CardContent>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Nombre del Grupo"
                name="nombre"
                value={grupo.nombre}
                onChange={handleChange}
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre}
              />
              <TextField
                fullWidth
                label="Descripción"
                name="descripcion"
                value={grupo.descripcion}
                onChange={handleChange}
                margin="normal"
                multiline
                rows={4}
                error={!!errors.descripcion}
                helperText={errors.descripcion}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={grupo.show}
                    onChange={handleChange}
                    name="show"
                    color="primary"
                  />
                }
                label="Mostrar Grupo"
              />
              <Box sx={{ mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  Crear Grupo
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default GroupCreate;